/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Injectable} from '@angular/core';
import * as moment from 'moment';
import {Observable} from 'rxjs';

import {ApiConfig} from '../config/api-config';
import {AdnApiClientService} from '../common/controller/adn-api-client.service';

export interface BurnRatesParams {
  startDate?: any;
  endDate?: any;
  [key: string]: any;
}

@Injectable({providedIn: 'root'})
export class BurnRatesApiService {
  constructor(private readonly client: AdnApiClientService, private readonly apiConfig: ApiConfig) {
  }

  getForLineItem(lineItemId: string, params: BurnRatesParams = {}): Observable<any> {
    const now = moment();
    const requestParams: Record<string, any> = {
      startDate: now.clone().subtract(7, 'd'),
      endDate: now,
      ...params
    };
    if (requestParams.startDate?.toISOString) {
      requestParams.startDate = requestParams.startDate.toISOString();
    }
    if (requestParams.endDate?.toISOString) {
      requestParams.endDate = requestParams.endDate.toISOString();
    }
    return this.client.request({
      method: 'GET',
      url: this.apiConfig.getVersionedUri(['burnrates', lineItemId]),
      params: requestParams
    });
  }
}
